import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../hooks/useAdminAuth";
import { usePermissions } from "../../contextapi/PermissionsContext";
import Loading from "../common/Loading";
import { Alert, AlertDescription } from "../ui/alert";
import { AlertTriangle } from "lucide-react";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
  /** If true, org admins are also allowed (default: system admin only) */
  allowOrgAdmin?: boolean;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({
  children,
  allowOrgAdmin = false,
}) => {
  const { isAdmin: isSysAdmin, isLoading: sysLoading, error } = useAdminAuth();
  const { isAdmin: isOrgAdmin, isLoading: orgLoading } = usePermissions();

  const isLoading = sysLoading || (allowOrgAdmin && orgLoading);
  const hasAccess = isSysAdmin || (allowOrgAdmin && isOrgAdmin);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen p-4">
        <Alert variant="destructive" className="max-w-md">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/tender" replace />;
  }

  return <>{children}</>;
};
